var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTournamentTicket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_698_24903)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 9H9a.5.5 0 000 1h2.5v4.5a.5.5 0 001 0V10H15a.5.5 0 000-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 12c0 1.82 1.263 3.408 3 3.858V19h-21v-3.142c1.737-.45 3-2.038 3-3.858 0-1.82-1.263-3.408-3-3.858V5h21v3.142c-1.737.45-3 2.038-3 3.858zm3.571-2.954a.5.5 0 00.429-.495V4.5A.5.5 0 0023 4H1a.5.5 0 00-.5.5v4.051a.5.5 0 00.429.495A3.005 3.005 0 013.5 12a3.005 3.005 0 01-2.571 2.954.5.5 0 00-.429.495V19.5a.5.5 0 00.5.5h22a.5.5 0 00.5-.5v-4.051a.5.5 0 00-.429-.495A3.005 3.005 0 0120.5 12a3.005 3.005 0 012.571-2.954z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_698_24903"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h24v24H0z"
  })))));
}
SvgTournamentTicket.displayName = 'TournamentTicket';
export default SvgTournamentTicket;